export default (ob => {
  try {
    return JSON.stringify(ob).length;
  } catch (err) {
    return -1;
  }
});